import React from 'react';
import { CartProvider } from './../Providers/CartProvider';
import { AppStore } from './../Core/AppStore';
import { Storage } from './../Core/Storage';
export default class CountDown extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {
				hours: '',
				days: '',
				minutes: '',
				seconds: ''
			},
			fade: true
		};
	}

	componentDidMount(props) {
		this.intervalHandle = setInterval(this.countdown, 500);
	}

	componentWillUnmount() {
		clearInterval(this.intervalHandle);
	}
	//


	countdown = () => {
		var currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
		var addDate = currentDate.getDate() + parseInt(this.props.daysToFinish);
		var dateFinish = currentDate.setDate(addDate) + 86400000;
		var t = (dateFinish - (new Date()).getTime()) / 1000; // diff in seconds
		if (t <= 0) {
			this.setState({ isActive: false });
			return;
		}
		var data = {
			hours: '',
			minutes: '',
			days: '',
			seconds: ''
		};
		var T = window.Texts.newsBox;

		var s = Math.floor(t % 60);
		t = t / 60;
		var m = Math.floor(t % 60);
		t = t / 60;
		var h = Math.floor(t % 24);
		t = t / 24;
		var d = Math.floor(t);
		var ds = '';
		if (d > 0) {
			data.days = d + ' ' + (d > 4 ? T.day5 : (d > 1 ? T.day2 : T.day1)) + ', ';
		}
		if (d || h > 0) {
			data.hours = h + ' ' + (h > 4 || h === 0 ? T.hour5 : (h > 1 ? T.hour2 : T.hour1)) + ', ';
		}
		if (d || h || m > 0) {
			data.minutes = m + ' ' + (m > 4 || m === 0 ? T.minute5 : (m > 1 ? T.minute2 : T.minute1)) + ', ';
		}
		if (d || h || m || s > 0) {
			data.seconds = s + ' ' + (s > 4 || s === 0 ? T.second5 : (s > 1 ? T.second2 : T.second1));
		}
		this.setState({ data: data, fade: false });
	}

	render() {
		var T = window.Texts.newsBox;
		if (this.props.daysToFinish > this.props.dayToCount || !this.props.isActivePage)
			return this.props.empty;//nic nevložim za předpokladu, že neni ake do 5 dnu a je to zpanuta stranka
		return (
			<div className="arrow_box ">
				<div className="abidea10-cd">
					<div id="abidea10-cd-in" className={this.state.fade ? 'faded' : ''}>
						<span className="abidea10-clock-icon" />
						{T.counter}
						<span id="abidea10-days"> {this.state.data.days}</span>
						<span id="abidea10-hours">{this.state.data.hours}</span>
						<span id="abidea10-minutes">{this.state.data.minutes}</span>
						<span id="abidea10-seconds">{this.state.data.seconds}</span>
					</div>
				</div>
			</div>);
	}
}

//inicializace

//if (window.Config && window.Config.mode != 'livehu')
{
	var element = document.querySelector('.product  .countdown');//detail productu

	var isDetail = false;
	var emptyResult = null;
	var additionalStyle = '';
	if (element) {//je to detail
		isDetail = true;
		emptyResult = <div className="arrow_box" />;
		additionalStyle = '.arrow_box {padding: 2px;}#abidea10-cd-in {opacity: 1;transition: opacity .5s ease-out;}#abidea10-cd-in.faded {opacity: 0}.abidea10-cd {background: #fff;padding: 15px 20px 15px 70px;position: relative;font-weight: bold;}.abidea10-cd:after {top: 100%;left: 50%;border: solid transparent;content: " ";height: 0;width: 0;position: absolute;pointer-events: none;border-top-color: #fff;border-width: 10px;margin-left: -43.3%;z-index: 3;}.abidea10-clock-icon {background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABOBAMAAACXs4YtAAAAD1BMVEVYVFNzbm2bl5bDwL/9//yxQOo9AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+IGFwU4Ngs4YSYAAAHgSURBVEjHzZZJooMgDEBBe4BaewBbPYCtHEDF+5/pMyRIQIbFXzSbFnkmJJKBHVWysp/h5KtjrHuLPLe8GMhDZLgP86RPcgTzQcoFmAcSboNd3nV3+DtdcNJuPsZFyOVr/eEi5gazM+Lya5ZNxJnDNSLUPwWcecpJdKWxHHDaCQ7H/oCfuwafhDPqeqdnOs/CCbedZ1YPrRIld1DouIEEy3E7vI6cXrdHzJn3xcl9PHWE261h5IbzdJTTO9xxkvlbhNuMYeA2EmLCWRXAzb5ZymnDLXIqTLcUp20BJ63z15zZXNku4JUUp409VyYZH2cvyDE3G07/0NwKObVsFYdZ0S8JTn2SRvuBOePucsApR7jm5iC3Qk4r0tweJzXlVKRnBpcx/T0MNzD7nGRQyKmD3RlEPBMX64A9aHvUcCvN2xXLEPfWJkLTccmBWsdFxRjl9i+cdJygfoTyfVsZjzwXCMa5JPjdKri5hoN7VRK8pyXBe1/ulSaPasLS13A2z2vc0HWjyHl1qBTltoIjdTJv9qy7ebNNxVwS9IWcOr/P5NQ1FfNQ1AevJe6rSatBn06FOOr7F9jlHBEncWIuIapyc84pr+zcRN3MzGFRveqPKq4vzLF7ee7ES1KcY39tHv8DSseK+ryIIpoAAAAASUVORK5CYII=") 50% 50% no-repeat;background-size: 100%;width: 20px;height: 20px;display: block;left: 39px;top: 12px;position: absolute;}#abidea10-seconds, #abidea10-days, #abidea10-minutes, #abidea10-hours {color: #e31d23}';
	}
	else {
		//zakladni styl
		additionalStyle = ".arrow_box {position: relative;background: #da1616;margin: 20px 0 0;padding: 2px;}.arrow_box:after {bottom: 100%;right: 151px;border: solid transparent;content: ' ';height: 0;width: 0;position: absolute;pointer-events: none;border-bottom-color: #da1616;border-width: 16px;}.abidea10-cd {background: #fff;padding: 15px 20px 15px 54px;position: relative;font-weight: bold;font-size: 18px;}#abidea10-cd-in {opacity: 1;transition: opacity .5s ease-out;line-height: 1.4;}#abidea10-cd-in.faded {opacity: 0}.abidea10-cd:after {bottom: 100%;right: 150px;border: solid transparent;content: ' ';height: 0;width: 0;position: absolute;pointer-events: none;border-bottom-color: #fff;border-width: 15px;z-index: 3;}.abidea10-clock-icon {background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAgMAAACdGdVrAAAADFBMVEUEBARRUVGmpqb+/v7BmAiRAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhklEQVQI12P4/38K2//3DP+/MDDIxzP8b8j/ycjP8I/t//8L3Aw/9MHUh/3//zuwM1z8/8d+KTvDYSD1/zdDO4j6z+ANon4x8IOohxDqK4gCYgZuEPULqAQIHgI1AMEjoHYQABoGBPlgo//xgy0C8kDW3v4PcsTv5v8gJ7HPB1L/J7D//w8AFYVmft7XrCAAAAAASUVORK5CYII=') 50% 50% no-repeat;background-size: 100%;width: 24px;height: 24px;display: block;left: 15px;top: 12px;position: absolute;}#abidea10-seconds,#abidea10-days,#abidea10-minutes,#abidea10-hours {color: #e31d23}";
		element = document.querySelector('.catalog-header > .cover > .countdown');
		if (element) {
			additionalStyle += ".arrow_box {margin: 25px 0 -30px;}.abidea10-cd {font-size: 15px;padding: 12px 20px 12px 52px;}.arrow_box:after{border-width: 11px;left:52px;bottom:auto;top: -21px;right: auto;margin-left:auto;}.abidea10-cd:after {border-width: 10px;left:51px}.abidea10-clock-icon {height:22px;width:22px}";
		}
		if (!element) {//test na hp
			element = document.querySelector('.pcol-main-hero-banner .countdown');
			if (element)
				additionalStyle += ".main-hero-banner .arrow_box:after{left:auto;bottom:auto;top:-30px} .abidea10-cd:after {right: 151px;border-width: 14px;}";
		}
		if (!element) {//test letak
			element = document.querySelector('.red-hero > .cover .countdown');
			if (element)
				additionalStyle += ".red-hero .arrow_box {max-width: 600px;margin: 30px auto 0;text-align: left;}.arrow_box:after{left:50%;bottom:auto;top:-32px;right:auto;margin-left:-16px} .abidea10-cd:after {left: 50%;margin-left:-15px}@media (min-width: 990px) {.red-hero {padding-bottom: 40px;}.abidea10-cd {background: #e31f24;color: #fff;font-weight: normal;font-size: 16px;padding: 8px 20px 8px 54px;}.arrow_box{background: #fff}.arrow_box:after{border-bottom-color: #fff;}.abidea10-cd:after {border-bottom-color: #e31f24;}#abidea10-seconds,#abidea10-days,#abidea10-minutes,#abidea10-hours{color:#fff;font-weight:bold}.abidea10-clock-icon {top: 7px;background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAgMAAACdGdVrAAAADFBMVEXlHyTxdXj1urz//Po3qO7LAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAgUlEQVQI12NgYMj/ySDAwMD9//+DBAaG+gls/z4wMP5gYND/wMB+gYFB/gsDvwNQ/AuDHgPzAbEfDDZAioGFoQJEMTBsAVGsDB9AFD+E4gJR/z8wQCgWoBIgkANqAAJZoHYw0AMRAWCjGSEWMUwAW6vCAHIEQw0DyEk/FEDK8oHCAHmDJ4IREBSVAAAAAElFTkSuQmCC');}}";
		}
	}
	if (element) {
		var daysToFinish = parseInt(element.getAttribute('data-finish'));
		var dayToCount = parseInt(element.getAttribute('data-count'));
		var isActivePage = element.getAttribute('data-isActivePage').toLowerCase() == "yes";
		var temp = document.createElement("div");
		if (additionalStyle) {
			var style = document.createElement("style");
			style.textContent = additionalStyle;
			document.body.appendChild(style);
		}
		ReactDOM.render(<CountDown dayToCount={dayToCount} daysToFinish={daysToFinish} isActivePage={isActivePage} empty={emptyResult} isDetail={isDetail} />, temp);

		// and replace the child
		if (temp.childNodes.length) {
			var container = element.parentNode;
			container.replaceChild(temp.childNodes[0], element);
		}
	}
}
